module.exports = __webpack_public_path__ + "static/media/Pandora.42df4953.jpg";